import AppSearch from './Search.vue';
import AppSearchBar from './SearchBar.vue';
import AppSearchView from './SearchView.vue';
import AppSearchBarPlaceholder from './SearchBarPlaceholder.vue';
import AppSearchBarIcon from './SearchBarIcon.vue';
import AppSearchBarAvatar from './SearchBarAvatar.vue';

export default { AppSearch, AppSearchBar, AppSearchView, AppSearchBarPlaceholder, AppSearchBarIcon, AppSearchBarAvatar };
